import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import { useDispatch } from "react-redux";
import TableRow from "@mui/material/TableRow";
import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  // FormHelperText,
  Grid,
  IconButton,
  Pagination,
  styled,
  TableFooter,
  TableHead,
  TablePagination,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import {
  CustomTableContainer,
  CustomTableHead,
  // TableContentVendorFont,
  TableHeaderFont,
} from "../../../styles/tableContent.style";
import {
  Delete,
  KeyboardArrowLeft,
  KeyboardArrowRight,
} from "@mui/icons-material";
import PropTypes from "prop-types";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import { DisplayText } from "../../bankDetails/components/bankAccountsContent";
import empty from "../../../assets/illo.png";
import { createInvoice, getOrders } from "../redux/userOrdersSlice";
import { Link } from "react-router-dom";
import moment from "moment";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import { useForm } from "react-hook-form";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import {
  CustomButton,
  StyledOutlineButton,
} from "../../vendorRegistration/components/StepMain";
import { LoadingButton } from "@mui/lab";
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";
import {
  Super,
  VendorCardSubTitle,
} from "../../vendorRegistration/components/steps/cardTrial";
import {
  StyledCard,
  // VendorCardLabel,
  VendorCardTitle,
} from "./userOrdersViewContent";
import { message } from "antd";
const EmptyContainer = () => (
  <Grid
    container
    spacing={0}
    direction="column"
    alignItems="center"
    justifyContent="center"
  >
    <br />
    <img src={empty} alt="empty" />

    <DisplayText> There are no orders to display</DisplayText>

    <br />

    <br />
  </Grid>
);

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };
  return (
    <>
      <Box sx={{ flexShrink: 0 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    </>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};
const Input = styled("input")({
  display: "none",
});
function UserOrdersTableContent() {
  const { pending } = useSelector((state) => state.pendinglist);
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState("");
  // const [document, setDocument] = React.useState("");
  const [addUploadDocumentModalOpen, setAddUploadDocumentModalOpen] =
    useState(false);
  const [documentsList, setDocumentsList] = useState([]);
  const [documentItemDetails, setDocumentItemDetails] = useState(null);
  const [documents, setDocuments] = useState("");

  const { ordersList, create_invoice_loading } = useSelector(
    (state) => state.userOrders
  );
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    // setError,
    // clearErrors,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

  const documentListColumns = [
    { key: "srNo", label: "Sr. No." },
    { key: "doc_title", label: "Document Title" },
    { key: "name", label: "Documents" },
    { key: "action", label: "Action" },
  ];
  const orders = () => {
    const payload = {
      rowsPerPage,
      page,
      search: "",
    };
    dispatch(getOrders(payload));
  };

  useEffect(() => {
    orders();
    // eslint-disable-next-line
  }, [page, rowsPerPage]);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - pending.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleClose = () => {
    reset();
    setOpenDialog(false);
    setAddUploadDocumentModalOpen(false);
    setDocumentItemDetails(null);
    setDocuments("");
    setDocumentsList([]);
    // setValue("PurchaseOrderNo",null);
    // setValue("order_number",null);
    // setValue("invoice_number",null);
    // setValue("invoice_amount",null);
    // setValue("invoice_date",null);
    // setValue("supplier_code",null);
  };
  const handleDocModalClose = (closeType) => {
    if (closeType === "inClose" || closeType === "outClose") {
      const userConfirmed = window.confirm(
        "Your entered item data will be lost. Do you want to close the dialog box?"
      );
      if (userConfirmed) {
        setAddUploadDocumentModalOpen(false);
        setDocumentItemDetails(null);
        setDocuments("");
      }
    }
    if (closeType === "uploadDocument") {
      setAddUploadDocumentModalOpen(false);
      setDocumentItemDetails(null);
      setDocuments("");
    }
  };
  const handleAddUploadDocumentModal = () => {
    setAddUploadDocumentModalOpen(true);
  };

  const handleAddDocumentData = () => {
    setDocumentsList([
      ...documentsList,
      {
        ...documentItemDetails,
        file: documents,
      },
    ]);
    handleDocModalClose("uploadDocument");
  };
  const handleChange = (event, type) => {
    const { name, value } = event.target;
    if (type === "doc_title") {
      setDocumentItemDetails((prev) => {
        const updatedDetails = {
          ...prev,
          [name]: value,
        };
        return updatedDetails;
      });
    }
  };

  const handleDeleteDoc = (id) => {
    const updatedItems = documentsList?.filter((item, index) => index !== id);
    setDocumentsList(updatedItems);
  };
  const onSubmit = (data) => {
    const formData = new FormData();
    const payload = {
      order_number: data?.PurchaseOrderNo,
      invoice_number: data?.invoice_number,
      invoice_amount: data?.invoice_amount,
      invoice_date: data?.invoice_date,
      supplier_code: data?.VendorCode,
      documents_name: documentsList?.map((doc) => ({
        document_title: doc?.doc_title,
        docs_name: doc?.file?.name,
      })),
    };

    formData.append("data", JSON.stringify(payload));
    for (let i = 0; i < documentsList?.length; i++) {
      formData.append("documents", documentsList[i]?.file);
    }
    dispatch(createInvoice(formData)).then((res) => {
      if (res.payload.success) {
        handleClose();
        orders();
      } else {
        message.error(res.payload.message);
      }
    });
  };

  return (
    <>
      <Dialog
        open={openDialog}
        onClose={() => handleClose()}
        aria-labelledby="draggable-dialog-title"
        fullWidth
      >
        <DialogTitle style={{ fontWeight: "Bold" }}>Create Invoice</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <form onSubmit={handleSubmit(onSubmit)}>
              <StyledCard>
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item md={6}>
                      <DialogContentText>Po Number</DialogContentText>
                      <TextField
                        style={{ width: "100%" }}
                        sx={{
                          input: {
                            fontSize: "14px",
                            fontFamily: "var(--font-family-reg)",
                          },
                        }}
                        value={selectedRow?.order_number}
                        variant="standard"
                        name="PurchaseOrderNo"
                        {...register("PurchaseOrderNo", {
                          value: selectedRow?.order_number,
                        })}
                        disabled
                      />
                    </Grid>
                    <Grid item md={6}>
                      <DialogContentText>Invoice Number</DialogContentText>
                      <TextField
                        style={{ width: "100%" }}
                        type="text"
                        sx={{
                          input: {
                            fontSize: "14px",
                            fontFamily: "var(--font-family-reg)",
                          },
                        }}
                        placeholder="Enter Invoice Number"
                        variant="standard"
                        name="invoice_number"
                        {...register("invoice_number", {
                          required: "Please enter Invoice Number",
                        })}
                        error={Boolean(errors?.invoice_number)}
                        helperText={errors.invoice_number?.message}
                      />
                    </Grid>
                    <Grid item md={6}>
                      <FormControl variant="standard" style={{ width: "100%" }}>
                        <DialogContentText>
                          Invoice Date <Super>*</Super>
                        </DialogContentText>

                        <TextField
                          sx={{
                            input: {
                              fontSize: "14px",
                              fontFamily: "var(--font-family-reg)",
                            },
                          }}
                          InputProps={{
                            disableUnderline: false,
                            disableInjectingGlobalStyles: true,
                          }}
                          InputLabelProps={{
                            disableAnimation: true,
                            disableInjectingGlobalStyles: true,
                          }}
                          size="small"
                          variant="standard"
                          type="date"
                          style={{
                            width: "100%",
                            borderBottom: errors?.invoice_date
                              ? "0"
                              : "1px solid lightgray",
                          }}
                          name="invoice_date"
                          placeholder="Select Invoice Date"
                          {...register("invoice_date", {
                            required: "Please Select Invoice Date",
                          })}
                          // value={datevalue || ""}
                          // onChange={(e) => handleinvdate(e)}
                          // inputProps={{
                          //   min: new Date(date).toISOString().split("T")[0], // Set the minimum date
                          // }}
                          error={Boolean(errors?.invoice_date)}
                          helperText={errors?.invoice_date?.message}
                        />
                      </FormControl>
                    </Grid>

                    <Grid item md={6}>
                      <DialogContentText>Invoice Amount</DialogContentText>
                      <TextField
                        style={{ width: "100%" }}
                        type="text"
                        inputMode="decimal"
                        sx={{
                          input: {
                            fontSize: "14px",
                            fontFamily: "var(--font-family-reg)",
                          },
                        }}
                        placeholder="Enter Invoice Amount"
                        variant="standard"
                        name="invoice_amount"
                        {...register("invoice_amount", {
                          required: "Please enter Invoice Amount",
                          pattern: {
                            value: /^\d+(\.\d+)?$/,
                            message: "Please enter a valid number",
                          },
                        })}
                        error={Boolean(errors?.invoice_amount)}
                        helperText={errors.invoice_amount?.message}
                      />
                    </Grid>
                    <Grid item md={6}>
                      <DialogContentText>Total PO Value</DialogContentText>
                      <TextField
                        style={{ width: "100%" }}
                        type="number"
                        sx={{
                          input: {
                            fontSize: "14px",
                            fontFamily: "var(--font-family-reg)",
                          },
                        }}
                        placeholder="Enter Total PO Value"
                        variant="standard"
                        value={selectedRow?.total_value}
                        name="total_value"
                        {...register("total_value", {
                          required: "Please Enter Total PO Value",
                          value: selectedRow?.total_value,
                        })}
                        error={Boolean(errors?.total_value)}
                        helperText={errors.total_value?.message}
                        disabled
                      />
                    </Grid>
                    <Grid item md={6}>
                      <DialogContentText>Remaining Amount</DialogContentText>
                      <TextField
                        style={{ width: "100%" }}
                        type="number"
                        sx={{
                          input: {
                            fontSize: "14px",
                            fontFamily: "var(--font-family-reg)",
                          },
                        }}
                        placeholder="Enter Remaining Amount"
                        variant="standard"
                        value={selectedRow?.remaining_amount || 0}
                        name="remaining_amount"
                        {...register("remaining_amount", {
                          required: "Please Enter Remaining Amount",
                          value: selectedRow?.remaining_amount || 0,
                        })}
                        disabled
                        error={Boolean(errors?.remaining_amount)}
                        helperText={errors.remaining_amount?.message}
                      />
                    </Grid>
                    <Grid item md={6}>
                      <DialogContentText>Supplier Code</DialogContentText>
                      <TextField
                        style={{ width: "100%" }}
                        sx={{
                          input: {
                            fontSize: "14px",
                            fontFamily: "var(--font-family-reg)",
                          },
                        }}
                        value={selectedRow?.VendorCode}
                        variant="standard"
                        name="VendorCode"
                        {...register("VendorCode", {
                          value: selectedRow?.VendorCode,
                        })}
                        disabled
                      />
                    </Grid>
                  </Grid>

                  <br />
                  <br />

                  <Grid container spacing={1}>
                    <Grid item md={6}>
                      <VendorCardTitle>Upload Document</VendorCardTitle>
                    </Grid>
                    <Grid item md={6} style={{ textAlign: "right" }}>
                      <Tooltip title={"Add Upload Document"}>
                        <CustomButton
                          size="small"
                          color="primary"
                          variant="outlined"
                          onClick={handleAddUploadDocumentModal}
                          className="invoiceErrbutn"
                          style={{ marginTop: "10px " }}
                        >
                          Add Upload Document
                        </CustomButton>
                      </Tooltip>
                    </Grid>
                  </Grid>

                  {documentsList?.length ? (
                    <CustomTableContainer component={Card}>
                      <Table aria-label="simple table">
                        <TableHead>
                          <TableRow
                            style={{
                              backgroundColor: "#e1ebfa",
                            }}
                          >
                            {documentListColumns.map((column, index) => (
                              <TableCell
                                key={index}
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                }}
                              >
                                {column?.label}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {documentsList.map((item, index) => (
                            <TableRow
                              key={index}
                              style={{
                                backgroundColor: "#fafcff",
                              }}
                            >
                              {documentListColumns.map((column) => (
                                <>
                                  <TableCell
                                    key={column.key}
                                    style={{
                                      fontFamily: "var(--font-family-reg)",
                                      fontSize: "12px",
                                      textAlign: column.align || "left",
                                    }}
                                  >
                                    {column?.key === "srNo" ? (
                                      index + 1
                                    ) : column.key === "name" ? (
                                      item?.file?.[column?.key]
                                    ) : column.key === "action" ? (
                                      <Tooltip title="Delete Item">
                                        <IconButton aria-label="delete">
                                          <Delete
                                            style={{
                                              fill: "royalblue",
                                              height: "18px",
                                              width: "18px",
                                            }}
                                            onClick={() =>
                                              handleDeleteDoc(index)
                                            }
                                          />
                                        </IconButton>
                                      </Tooltip>
                                    ) : item[column?.key] ? (
                                      item[column?.key]
                                    ) : (
                                      "-"
                                    )}
                                  </TableCell>
                                </>
                              ))}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </CustomTableContainer>
                  ) : (
                    <Typography className="label">
                      No document added yet. Start by adding an document.
                    </Typography>
                  )}
                </CardContent>
              </StyledCard>
              <Grid
                sx={{
                  display: "flex",
                  gap: "1rem",
                  justifyContent: "end",
                  alignItems: "center",
                  marginTop: "1rem",
                }}
              >
                <Button
                  autoFocus
                  onClick={handleClose}
                  style={{ height: "40px", border: "#4059e5 solid 1px" }}
                >
                  Cancel
                </Button>
                <LoadingButton
                  sx={{
                    textTransform: "none",
                    background: "#4059e5",
                    width: "200px",
                    height: "40px",
                  }}
                  color="primary"
                  variant="contained"
                  type="submit"
                  loading={create_invoice_loading}
                  loadingPosition="start"
                >
                  Submit
                </LoadingButton>
              </Grid>
            </form>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <Dialog
        open={addUploadDocumentModalOpen}
        onClose={(e) => handleDocModalClose("outClose")}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {"Enter Upload Document Details"}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={6}>
            <Grid item md={4}>
              <VendorCardSubTitle>Title</VendorCardSubTitle>
              <TextField
                sx={{
                  input: {
                    fontSize: "14px",
                    fontFamily: "var(--font-family-reg)",
                  },
                }}
                placeholder="Enter Title"
                type="text"
                size="small"
                variant="standard"
                style={{ width: "100%", paddingTop: "3px" }}
                name="doc_title"
                value={documentItemDetails?.doc_title ?? ""}
                onChange={(e) => {
                  handleChange(e, "doc_title");
                }}
              />
            </Grid>
            <Grid item xs={4} sx={{ display: "flex", alignItems: "end" }}>
              {documents !== "" ? (
                <>
                  <span
                    style={{
                      color: "#4945FF",
                      fontSize: "13px",
                      fontFamily: "var(–font-family-reg)",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Chip
                      style={{
                        width: "150px",
                        color: "#4945FF",
                        // margin: "5px",
                        borderRadius: "5px",
                        border: "1px solid #D9D8FF",
                        background: "#F0F0FF",
                      }}
                      label={documents.name}
                      value={documents.name}
                      name="chips"
                    />
                    <HighlightOffIcon
                      sx={{ color: "#4945FF", paddingBottom: "2px" }}
                      fontSize="medium"
                      onClick={(e) => setDocuments("")}
                    />
                  </span>
                </>
              ) : (
                <label htmlFor="dealer">
                  <Input
                    accept="*"
                    id="dealer"
                    name="dealer"
                    onChange={(e) => setDocuments(e.target.files[0])}
                    type="file"
                  />
                  <StyledOutlineButton variant="outlined" component="span">
                    Upload
                  </StyledOutlineButton>
                  <span>{documents.name}</span>
                </label>
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={(e) => handleDocModalClose("uploadDocument")}
            variant="outlined"
            style={{
              borderColor: "var(--button-color)",
              color: "black",
            }}
            size="small"
          >
            Close
          </Button>
          <Button
            variant="contained"
            style={{
              float: "right",
              backgroundColor: "success",
              color: "white",
            }}
            onClick={handleAddDocumentData}
            autoFocus
            disabled={
              !documentItemDetails?.doc_title?.trim()?.length || !documents
            }
            size="small"
          >
            {"Add"}
          </Button>
        </DialogActions>
      </Dialog>
      <CustomTableContainer component={Card}>
        <Table aria-label="simple table">
          <CustomTableHead>
            <TableRow>
              <TableCell align="left">
                <TableHeaderFont>PO Number </TableHeaderFont>
              </TableCell>
              <TableCell align="left">
                <TableHeaderFont>PO Type</TableHeaderFont>
              </TableCell>
              <TableCell align="left">
                <TableHeaderFont>PO Date</TableHeaderFont>
              </TableCell>
              <TableCell align="left">
                <TableHeaderFont>PO Total Value</TableHeaderFont>
              </TableCell>
              <TableCell align="left">
                <TableHeaderFont>Status</TableHeaderFont>
              </TableCell>
              <TableCell align="center">
                <TableHeaderFont>Action</TableHeaderFont>
              </TableCell>
            </TableRow>
          </CustomTableHead>
          {ordersList?.data?.length !== 0 ? (
            <TableBody>
              {ordersList?.data?.map((row) => (
                <TableRow
                  key={row.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    <Link
                      style={{ textDecoration: "none" }}
                      // eslint-disable-next-line
                      to={"/app/orders-list-view/" + `${row.id}`}
                    >
                      {row.order_number !== null
                        ? row.order_number
                        : "Not Applicable"}
                    </Link>
                  </TableCell>

                  <TableCell>
                    {row.order_type !== null
                      ? row.order_type
                      : "Not Applicable"}
                  </TableCell>
                  <TableCell>
                    {row.order_date !== null
                      ? moment(row.order_date).format("DD MMM YY")
                      : "Not Applicable"}
                  </TableCell>
                  <TableCell>
                    {row.total_value !== null
                      ? row.total_value
                      : "Not Applicable"}
                  </TableCell>
                  <TableCell>
                    {row.status !== null ? (
                      <Chip
                        label={
                          row.status
                            ? row.status.toUpperCase()
                            : "Not Applicable"
                        }
                        color={row.status === "Pending" ? "warning" : "success"}
                        size="small"
                        style={{ fontSize: "9px" }}
                      />
                    ) : (
                      "Not Applicable"
                    )}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    <Link
                      style={{ textDecoration: "none" }}
                      // eslint-disable-next-line
                      to={"/app/orders-list-view/" + `${row.id}`}
                    >
                      <RemoveRedEyeIcon
                        style={{
                          fill: "royalblue",
                          height: "18px",
                          width: "18px",
                        }}
                      />
                    </Link>
                    {row?.status === "Accepted" && (
                      <>
                        <Link
                          style={{ textDecoration: "none" }}
                          // eslint-disable-next-line
                          to={"/app/asns/" + `${row.id}`}
                        >
                          <Tooltip title="Create ASN">
                            <DescriptionRoundedIcon
                              color="action"
                              fontSize="small"
                              style={{
                                fill: "royalblue",
                              }}
                            />
                          </Tooltip>
                        </Link>
                        <IconButton
                          onClick={() => {
                            setSelectedRow(row);
                            setOpenDialog(true);
                          }}
                        >
                          <Tooltip title="Create Invoice">
                            <AddBoxOutlinedIcon
                              color="action"
                              fontSize="small"
                            />
                          </Tooltip>
                        </IconButton>
                      </>
                    )}
                  </TableCell>
                </TableRow>
              ))}
              {emptyRows > 0 && (
                <TableRow style={{ height: 0 * emptyRows }}></TableRow>
              )}
            </TableBody>
          ) : (
            <TableBody>
              <TableRow>
                <TableCell colSpan={8}>
                  <CustomTableContainer>
                    <EmptyContainer />
                  </CustomTableContainer>
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>

        <Grid
          container
          className="d-flex flex-row align-items-center justify-content-between w-100 px-3 text-muted"
          sx={{ height: "10vh", borderTop: "1px solid lightgray" }}
        >
          <Grid className="d-flex align-items-center gap-2">
            <span>Rows per page: </span>
            <select
              value={rowsPerPage}
              onChange={(e) => {
                setRowsPerPage(e.target.value);
                setPage(1);
              }}
            >
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
          </Grid>

          <Pagination
            sx={{
              width: "max-content",
            }}
            color="primary"
            variant="text"
            onChange={(_, newValue) => setPage(newValue)}
            count={ordersList?.pagination?.total_page}
            page={page}
            shape="rounded"
            onRowsPerPageChange={handleChangeRowsPerPage}
            showFirstButton
            showLastButton
          />
        </Grid>
      </CustomTableContainer>
    </>
  );
}

export default UserOrdersTableContent;
